import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadButton from './DownloadButton';

export default function Footer(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex h-fit min-h-[64px] w-full px-4 md:px-8 lg:px-32">
      <div className="mx-auto flex w-full flex-col justify-between gap-4 border-t-[1px] border-t-primary-900 border-opacity-10 px-4 py-4 text-primary-900 text-opacity-50 md:flex-row md:gap-0 md:px-8 md:py-8">
        <div className="flex flex-col gap-2 md:gap-4">
          <div className="md:text-md mb-1 flex flex-wrap gap-2 text-left text-sm underline md:mb-2 md:gap-4">
            <a href="https://www.veraconnect.com" target="_blank" rel="noreferrer">
              Vera Connect
            </a>
            <a href="https://www.veraconnect.com/privacy-statement" target="_blank" rel="noreferrer">
              Privacy
            </a>
            <a href="https://www.veraconnect.com/about" target="_blank" rel="noreferrer">
              {t('footer.about')}
            </a>
            <a href="https://www.veraconnect.com/contact" target="_blank" rel="noreferrer">
              Contact
            </a>
          </div>
          <p className="text-sm text-primary-900 text-opacity-50 md:text-base">
            {`® ${new Date().getFullYear()} Vera Connect`}
          </p>
        </div>
        <div className="flex justify-center md:justify-end">
          <DownloadButton className="items-center" />
        </div>
      </div>
    </div>
  );
}
